module.exports = __webpack_public_path__ + "static/media/mtg-min.e12e938e.png";